/*
    Пример использования debounce:

    const debounceScroll = debounce(() => {
        do stuff...
    }, 100);

    App.W.on('scroll', () => {
        debounceScroll();
    });
*/

export function debounce(func, wait, immediate) {
    let timeout;

    return function () {
        let context = this,
            args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

/*
    Пример использования throttle:

    function throttleScroll() {
        do stuff...
    }

    App.W.on('scroll', throttle(throttleScroll, 100));
*/

export function throttle(callable, wait) {
    let id;

    function call(context, list) {
        requestAnimationFrame(function () {
            callable.apply(context, list);
            id = 0;
        });
    }

    return function () {
        if (id) return;
        id = setTimeout(call, wait, this, arguments);
    };
}

/*
    Получение GET-параметров из строки
*/

export function getUrlVars() {
    let hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
    let vars = [];
    let hash;

    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

export function getUrlVar(name) {
    return getUrlVars()[name];
}

/*
    Скролл страницы вверх независимо от истории браузера
*/

export function scrollTopForce() {
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }
}

/*
    Разбиение чисел на разряды (1000000 => 1 000 000)
*/

export function numberDivide(string) {
    if (string) {
        return string.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1 ");
    } else {
        return string;
    }
}

export function scrollToElement(element) {
    if (!element || !element.length) return;
    let delta = App.mobile ? 56 : 64;

    //App.H.animate({'scrollTop': element.offset().top - delta});
    // $("html, body").animate({ scrollTop: element.offset().top - delta });
}

/*
    Склонение числительных
    Пример: declOfNum(count, ['комната', 'комнаты', 'комнат']);
*/

export function declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[
        number % 100 > 4 && number % 100 < 20
            ? 2
            : cases[number % 10 < 5 ? number % 10 : 5]
    ];
}

/*
   Находится ли обьект в поле зрения
*/

export function isInViewport(elem) {
    const bounding = elem.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)
    );
}

/*
   Находится ли обьект в поле зрения с отступом
*/
export function isInViewportOffset(elem, offset) {
    const bounding = elem.getBoundingClientRect();

    return (
        bounding.top >= 0 &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) -
                offset
    );
}

export function isInViewportArea(elem, area = 1) {
    // visiblePart = 1 видно 100% блока
    const bounding = elem.getBoundingClientRect();
    const wh = window.innerHeight || document.documentElement.clientHeight;

    if (bounding.top >= 0 && bounding.top < wh) {
        if (wh - bounding.top >= bounding.height * area) {
            return true;
        }
    } else if (bounding.bottom <= wh && bounding.bottom >= 0) {
        if (wh - bounding.bottom >= bounding.height * area) {
            return true;
        }
    }

    return false;
}

export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function showFromFade(element, startPosition) {
    if (!element.classList.contains('_no-fade-animation')) {
        gsap.fromTo(
            element,
            {
                "will-change": "opacity, transform",
                opacity: 0,
                transform: "translate(0, 50px)",
            },
            {
                ease: "none",
                opacity: 1,
                transform: "translate(0, 0)",
                stagger: 0.05,
                pin: 1,
                scrollTrigger: {
                    // markers: true,
                    trigger: element,
                    start: startPosition,
                    end: "center top+=50%",
                },
            }
        );
    }
}


export function loadLibrary(urls, callback) {
    const loadPromises = window.loadLibraryPromises = window.loadLibraryPromises || {};

    if (typeof urls == 'string') {
        if (!loadPromises[urls]) {
            loadPromises[urls] = new Promise(resolve => {
                load(urls, resolve);
            });
        }

        return loadPromises[urls]
            .then(() => callback());
    } else if (urls instanceof Array) {
        urls
            .filter(url => !loadPromises[url])
            .forEach(url => {
                loadPromises[url] = new Promise(resolve => {
                    load(url, resolve);
                });
            });

        return Promise.all(urls.map(url => loadPromises[url]))
            .then(() => callback());
    }

    function load(url, resolve) {
        $.ajax({
            url: url,
            dataType: "script",
            cache: true,
            success: (data, textStatus, jqXHR) => {
                resolve();
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log('loadLibrary', textStatus, url, errorThrown);
            }
        });
    }
}
